/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
import { branches } from 'src/dummydata/branches';

const findBranchColor = (id: number) => {
  if (id >= 0) {
    const selectedBranch = branches.find((x) => id === x.id);
    if (selectedBranch) {
      return selectedBranch.color;
    }
  }

  return '#000000';
};

export default findBranchColor;
